import React from "react"
//import I18n from "i18n-js/index.js.erb"
import ModalButtons from "../ModalButtons/ModalButtons"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import MoveFolioItemsTabs from "./MoveFolioItemsTabs"
import MoveFolioItemsTabContent from "./MoveFolioItemsTabContent"
import Tabs from '../Tabs/Tabs';


class MoveFolioItems extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active_tab: this.props.active_tab || "move-folio-items-general",
     reservation_segment: this.props.reservation_segment,
     folio: null,
     loading: false,
     note_obj: this.props.note || {
       note: null,
       notable_type: null,
       notable_id: null,
       flagged: false,
       user: null,
       created_at: null,
       updated_at: null
     },
     image_group: this.props.image_group,

   }
   this.onChangeFolio = this.onChangeFolio.bind(this)
   this.onChangeReservationSegment = this.onChangeReservationSegment.bind(this)
   this.onSave = this.onSave.bind(this)
   this.onChangeNote= this.onChangeNote.bind(this);
   this.onChangeImageGroup = this.onChangeImageGroup.bind(this);
   this.onChangeFlagged = this.onChangeFlagged.bind(this);
   this.onChangeActiveTab = this.onChangeActiveTab.bind(this);

  }

  render() {
    var self = this
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          e.stopPropagation()
          e.preventDefault()

          self.onSave()
        }
      }
    ]

    return(
      <div className="move-folio-items" ref="root">
        <div className="panel panel-form">
          <Tabs tabs={this.tabs()} displayErrorMessage={false} />
          {/* <MoveFolioItemsTabs {...this.state} onChangeActiveTab={this.onChangeActiveTab} /> */}
          <MoveFolioItemsTabContent {...this.state}
            buttons={buttons}
            date_format={this.props.date_format}
            time_format={this.props.time_format}
            move_folio_items_data_table_path={this.props.move_folio_items_data_table_path}
            folio_items={this.props.folio_items}
            read_only={this.props.read_only}
            onChangeFolio={this.onChangeFolio}
            onChangeReservationSegment={this.onChangeReservationSegment}
            onChangeNote={this.onChangeNote}
            onChangeImageGroup={this.onChangeImageGroup}
            onChangeFlagged={this.onChangeFlagged}
          />
        </div>


        <LoadingSpinner show={this.state.loading} />
        <ModalButtons loading={this.state.loading} buttons={buttons} />
      </div>

    )
  }

  tabs() {
    return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'move-folio-items-general',
            classes: this.state.active_tab === 'move-folio-items-general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
            // tabErrorCount: RateBuilderErrors.general(this.state.errors).length
          },
          {
            tabName: I18n.t('notes'),
            targetName: 'move-folio-items-notes',
            classes: this.state.active_tab === 'move-folio-items-notes' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
            // tabErrorCount: RateBuilderErrors.billing_policy(this.state.errors).length
          },
        ]
    );
  };

  onSave() {
    var self = this;

    self.setState({loading: true})

    $.ajax({
      type: 'POST',
      url: self.props.form_action,
      data: {
        folio_item_ids: this.props.folio_items.map((folio_item) => { return folio_item.id}),
        folio_id: this.state.folio ? this.state.folio.id : null,
        note: self.state.note_obj,
        image_group_images: self.state.image_group && self.state.image_group.images ? self.state.image_group.images.map(function (image) { return image.id; }) : null,

      },
    }).done(function(data) {
      if (data.errors && data.errors.length) {
        self.setState({errors: {folio: data.errors}, loading:false})
      } else {
        if (parent && parent.refresh_data) {
          parent.refresh_data(I18n.t("folio_items_moved_successfully"))
        }

        window.parent.$(window.parent).trigger("folio_items_moved_successfully")
        
        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
      }
    })

  }

  onChangeFolio(folio) {
    this.setState({folio: folio})
  }

  onChangeReservationSegment(reservation_segment) {
    this.setState({
      folio: null,
      reservation_segment: reservation_segment,
    })
  }

  onChangeActiveTab(active_tab) {

    this.setState({active_tab: active_tab})
  }

  onChangeImageGroup(image_group) {
    this.setState({image_group: image_group});
  }

  onChangeNote(noteText) {
    if (noteText) {
      var note_obj = Object.assign({}, this.state.note_obj)
      note_obj.note = noteText

      this.setState({
        note_obj: note_obj
      })
    }
  }

  onChangeFlagged(event) {
    var note_obj = this.state.note_obj;
    note_obj['flagged'] = event
    this.setState({note_obj: note_obj});
  }



}

export default MoveFolioItems
